import CanvasOcclusal from './CanvasOcclusal';
export default CanvasOcclusal;
